/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import Box from 'relements/build/esm/ui/box';

import Skeleton from '@src/components/Skeleton';

import initFB from './utils';

// "FB" variable used in this component is initialised by fb once script is loaded
// this script is loaded through initFB method
const Login = ({ loginCallback, buttonText, appId }) => {
  const doesFBExist = typeof FB === 'undefined';
  const [showButtonLoader, setShowButtonLoader] = useState(doesFBExist);

  const fbButtonRenderStatus = () => {
    setShowButtonLoader(false);
  };

  useEffect(() => {
    const callback = () => {
      FB.Event.subscribe('auth.authResponseChange', loginCallback);
      FB.Event.subscribe('xfbml.render', fbButtonRenderStatus);
    };
    initFB({ callback, appId });

    if (!doesFBExist) {
      callback();
      // fb renders button only once after init,
      // to render as a fb button again this parser needs to be called
      FB.XFBML.parse();
    }
    return () => {
      if (!doesFBExist) {
        FB.Event.unsubscribe('auth.authResponseChange', loginCallback);
        FB.Event.unsubscribe('xfbml.render', fbButtonRenderStatus); // callback is triggered once fb button is rendered
      }
    };
  }, []);

  return (
    <>
      {showButtonLoader && <Skeleton height="40px" width="228px" animation />}
      <Box
        className="fb-login-button fb_iframe_widget"
        data-size="large"
        data-layout="default"
        data-button-type={buttonText}
        data-auto-logout-link="false"
        data-use-continue-as="false"
        login_text=""
        data-scope="instagram_basic,instagram_manage_messages,pages_read_engagement,pages_show_list,pages_manage_metadata,business_management"
        padding={0}
      />
    </>
  );
};

export default Login;
